import React from "react";
import EditCategoryForm from "../Components/Products/EditSubCategory/EditSubCategoryForm";

function EditProductsSubCategory() {
  return (
    <div className="p-9">
      <EditCategoryForm />
    </div>
  );
}

export default EditProductsSubCategory;
